module.exports = __webpack_public_path__ + "static/img/swiper18.d037bea7.png";